module.exports = __webpack_public_path__ + "static/media/newfeature.702c5893.svg";